<template>
  <div :class="'custom-tooltip-status0'">
    <div class="tooltip_view_box">
      <template >
        <div class="close_status1"
             @click="hideCustomTooltip">
          关闭
        </div>

        <div class="title">
          {{ tData.factory_name }}
        </div>

        <div class="content_status1">
          <div class="content_two_box">
            <div style="width: 50%;">在职分销者：{{ tData?.census_data?.count_online_user }}</div>
            <div style="width: 50%;">自由分销者：{{ tData?.census_data?.count_free_user }}</div>
          </div>
          <div class="content_two_box">
            <div style="width: 50%;">
              {{ timeLabelLocal }}有效付款订单总数：{{ tData?.census_data?.count_order }}
            </div>
            <div style="width: 50%;">
              {{ timeLabelLocal }}有效付款总金额：{{ tData?.census_data?.sum_pay_amount }}
            </div>
          </div>
          <div>{{ timeLabelLocal }}有效付款预估服务费：{{ tData?.census_data?.sum_service_amount }}</div>
          <div class="content_two_box">
            <div style="width: 50%;">
              {{ timeLabelLocal }}发货总数：{{ tData?.census_data?.count_express_sample }}
            </div>
            <div style="width: 50%;">
              {{ timeLabelLocal }}申样达人：{{ tData?.census_data?.distinct_talent_num }}
            </div>
          </div>
          <div class="content_two_box">
            <div style="width: 50%;">{{ timeLabelLocal }}申样总数：{{
                tData?.census_data?.count_sample
              }}
            </div>
            <div style="width: 50%;">
              {{ timeLabelLocal }}出单达人：{{ tData?.census_data?.count_distinct_customer }}
            </div>
          </div>
        </div>
      </template>
    </div>
  </div>

</template>


<script>
export default {
  props: {
    tData: {
      type: Object,
      default: {}
    },
    timeLabelLocal: {
      type: String,
      default: ''
    },
    hideCustomTooltip: {
      type: Function,
      default: () => {
      }
    },
  },
  components: {},
  data() {
    return {}
  },
  methods: {},
  beforeDestroy() {
  },
  mounted() {
  },
}
</script>

<style lang="scss" scoped>

.tooltip_view_box {
  padding: 0 20px;

  .close_status1 {
    position: absolute;
    right: 7px;
    cursor: pointer;
    pointer-events: auto; /* 允许关闭按钮接收鼠标事件 */
  }

  .title {
    font-size: 24px;
    font-weight: 700;
    padding-top: 10px;
  }

  .content_status1 {
    height: 190px;
    display: flex;
    flex-direction: column;
    padding-top: 12px;
    gap: 12px;
  }

  .content_two_box {
    display: flex;
  }

}


.custom-tooltip-status0 {
  width: 580px;
  height: 270px;
  background: url(../../assets/_s-image_map_operation.png) no-repeat;
  background-size: 580px 270px;
}
</style>